import React, { useCallback, useState, useEffect } from 'react'
import styled from 'styled-components'

import { useDebounce } from 'use-lodash-debounce'




const PaginationButtonStyled = styled.li`
  background-color: ${props => (props.selected ? "#5d9cec !important" : "inherit")};
  color: ${props => (props.selected ? "white !important" : "inherit")};
`;


const PaginationIcon = styled.div`
  font-size: ${props => (props.fontSize ? props.fontSize : "20")}px;
  position: relative;
  top: 1px;
`;

const PaginationStepBtn = styled.button`
  width: 40px;
  text-align: center;
  font-size: 20px;
  display: inline-block;
  border-radius: 0px;
  border: none;
  background: none;

  outline: 0 !important;
  cursor: pointer;

  transition: all 0.3s ease;
  color: rgb(0, 0, 0, 0.2) !important;

  &:disabled {
    color: rgb(216, 216, 216) !important;
  }

  &:hover {
    background-color: rgb(216, 216, 216, 0) !important;
    color: #1890ff !important;
    opacity: 0.7;
  }
`;

const PaginationBtn = styled.div`
  width: 80px;
  text-align: center;
  font-size: 20px;
  display: inline-block;
  border-radius: 60px;

  font-weight: 300;
`;

const PaginationWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 1em 3em;
`;

const PaginationLeft = styled.div`
  display: flex;
  min-width: 90px;
  justify-content: space-between;
`;

const PaginationCenter = styled.div``;

const PaginationText = styled.div`
  font-size: 14px;
  padding: 8px 0px;
  border: none;
  color: rgba(0, 0, 0, 0.2);
  font-weight: 400;
`;

const PaginationRight = styled.div`
  display: flex;
  min-width: 90px;
  justify-content: space-between;
`;



const PaginationBar = props => {
    const { totalCount = 100, pageSize = 10, page = 2, loading= false, setPage = () => {} } = props;

  
    // calculate pagination
    var numPaginationButtons = Math.ceil(totalCount / pageSize);

    const [ debouncedPage,setDebouncedPage ] = useState(page)

    const _setPage = useCallback( e => {
      const toPage = e.currentTarget.dataset.page;
      setDebouncedPage(toPage)
    })


    const debouncedValue = useDebounce(debouncedPage, 250);

    useEffect(() => {
        setPage(debouncedValue)
    }, [debouncedValue])

    return (
      <PaginationWrapper>
        <PaginationLeft>
          <PaginationStepBtn
            disabled={+debouncedPage === 1 ? true : false || loading}
            data-page={1}
            onClick={+debouncedPage === 0 ? () => {} : _setPage}>
            <PaginationIcon fontSize={20} className="far fa-arrow-to-left" />
          </PaginationStepBtn>
          <PaginationStepBtn
            disabled={+debouncedPage === 1 ? true : false || loading}
            data-page={+debouncedPage-1}
            onClick={+debouncedPage === 0 ? () => {} : _setPage}>
            <PaginationIcon className="far fa-angle-left" style={{ fontSize: "20" }} />
          </PaginationStepBtn>
        </PaginationLeft>
        <PaginationCenter>
          <PaginationBtn>
            <PaginationText>{`${debouncedPage} / ${numPaginationButtons}`} </PaginationText>
          </PaginationBtn>
        </PaginationCenter>
        <PaginationRight>
          <PaginationStepBtn
            disabled={+debouncedPage === +numPaginationButtons ? true : false || loading}
            data-page={+debouncedPage+1}
            onClick={+debouncedPage === +numPaginationButtons ? () => {} : _setPage}>
            <PaginationIcon className="far fa-angle-right" style={{ fontSize: "20" }} />
          </PaginationStepBtn>
          <PaginationStepBtn
            disabled={+debouncedPage === +numPaginationButtons ? true : false || loading}
            data-page={+numPaginationButtons}
            onClick={+debouncedPage === +numPaginationButtons ? () => {} : _setPage}>
            <PaginationIcon fontSize={20} className="far fa-arrow-to-right" />
          </PaginationStepBtn>
        </PaginationRight>
      </PaginationWrapper>
    );
  };
  
  export default PaginationBar